import React from 'react';
import { showIndependentModal } from 'lib/components/Modal';
import IndependentDialog from '../IndependentDialog';
import './index.scss';

interface LongTextTipsDialogProps {
  title?: string;
  content?: string | React.ReactNode;
  buttonText?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  closeModal?: () => void;
  customClass?: string;
}

const LongTextTipsDialog = ({
  title = '温馨提醒',
  content,
  buttonText = '我知道了',
  onConfirm,
  onClose,
  closeModal,
}: LongTextTipsDialogProps) => {
  const handleConfirm = () => {
    closeModal?.();
    onConfirm?.();
  };

  return (
    <IndependentDialog
      title={title}
      customClass="long-text-tips-modal"
      closeCallback={onClose}
      showConfirm={false}
      closeModal={closeModal}
      keyboard={{ onEnter: handleConfirm, onEscape: () => closeModal?.() }}
    >
      <div className="long-text-tips-modal__content">
        {typeof content === 'string' ? <div className="long-text-tips-modal__content-text">{content}</div> : content}
        <div className="long-text-tips-modal__content-confirm-button" onClick={handleConfirm}>
          {buttonText}
        </div>
      </div>
    </IndependentDialog>
  );
};

export const showLongTextTipsDialog = (params: Omit<LongTextTipsDialogProps, 'closeModal'>) =>
  showIndependentModal(<LongTextTipsDialog {...params} />);

export default LongTextTipsDialog;
